/* The three official documents, transcribed. */
export const DOCUMENT_SPECS = [
  {
    /* The section label in editSections, so the rail's entry can be matched
       to the slot it scrolls to. */
    section: "MOA",
    /* The design's own wording: two say "Upload …", the third does not. */
    label: "Upload MOA",
    updateLabel: "Update MOA",
    /* The field on the company this document is stored under. */
    field: "MOA",
    /* The upload endpoint's category for it. A CLOSED set — see F-067. */
    category: "moa",
  },
  {
    section: "Trade License",
    label: "Upload Trade License",
    updateLabel: "Update Trade License",
    field: "trade_license",
    /* Transcribed: the trade licence goes to the STAGING category, because a
       replacement is reviewed before it becomes the company's licence. */
    category: "trade_license_staging",
  },
  {
    section: "VAT Certificate",
    label: "VAT Certificate",
    updateLabel: "Update VAT Certificate",
    field: "VAT_certificate",
    category: "vat_certificate",
  },
];

export const findDocumentSpec = (section) =>
  DOCUMENT_SPECS.find((d) => d.section === section) || null;

/* Every document on the flow shares one S3 folder — `uploadFilePath.moa` —
   which is what the live upload passes for all three. */
export const DOCUMENT_UPLOAD_PATH = "moa";

/* A stored value is a URL; anything else (an empty string, null) means the
   slot is still empty. */
export const hasDocument = (company, spec) =>
  Boolean(company?.[spec.field]);

/* Transcribed: the filename shown under a preview is the last path segment of the stored URL, with its query string dropped. */
export const documentFileName = (url) => {
  const text = String(url || "");
  if (text === "") return "";
  const withoutQuery = text.split(/[?#]/)[0];
  const last = withoutQuery.split("/").filter(Boolean).pop() || "";
  try {
    return decodeURIComponent(last);
  } catch {
    /* A malformed escape must not blank the name. */
    return last;
  }
};

/* Whether that last segment is actually a file rather than an opaque id. */
const DOCUMENT_EXTENSIONS = /\.(pdf|jpe?g|png)$/i;

export const looksLikeFileName = (segment) =>
  DOCUMENT_EXTENSIONS.test(String(segment || ""));

/* What to print under a preview: the real filename when the URL carries one,
   and the document's own name when it does not. */
export const documentDisplayName = (url, fallback = "") => {
  const name = documentFileName(url);
  return looksLikeFileName(name) ? name : fallback;
};

export const isPdfDocument = (url) =>
  /\.pdf(?:$|[?#])/i.test(String(url || ""));
